/* eslint-disable max-len */
import {Boot} from '@/project'

/**
 * Register Google Optimize code
 * @export default
 */
const boot: Boot = ({Vue}) => {
  if(process.env.VUE_APP_GO_ID) {
    Vue.scriptCodeInjector('google-optimize', '', {
      src:'https://www.googleoptimize.com/optimize.js?id='+process.env.VUE_APP_GO_ID,
      async: false,
    })
  }
}

export default boot
